import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "data-selector" }
const _hoisted_2 = { class: "group-selector is-hidden-touch" }
const _hoisted_3 = { class: "is-hidden-desktop" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-wrench-clock" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.groups && _ctx.groups.length > 1 && _ctx.group)
        ? (_openBlock(), _createBlock(_component_n_select, {
            key: 0,
            value: _ctx.group.id,
            options: _ctx.options,
            "default-value": _ctx.group?.id,
            "render-label": _ctx.renderLabel,
            "onUpdate:value": _ctx.onSelectionChange,
            size: "large",
            checkable: ""
          }, null, 8 /* PROPS */, ["value", "options", "default-value", "render-label", "onUpdate:value"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.group)
        ? (_openBlock(), _createBlock(_component_n_dropdown, {
            key: 0,
            trigger: "click",
            value: _ctx.group.id,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.group.id) = $event)),
            options: _ctx.options,
            size: "large",
            onSelect: _ctx.onDropdownSelect,
            "render-label": _ctx.renderLabel,
            checkable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, { size: "large" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value", "options", "onSelect", "render-label"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}